import type { ICartLiteResponse, ICartFullResponse, ICartUpdateDto } from './models';
import type { Options } from 'ky';

import { MMGatewayClient } from '../MMGatewayClient';
import { MMGatewayConfig } from '../config';

class _CartClient extends MMGatewayClient {
  public async getCartLite(): Promise<ICartLiteResponse> {
    return this.get<ICartLiteResponse>('v1/carts/lite');
  }

  public async putCartLite(data: ICartUpdateDto): Promise<ICartLiteResponse> {
    return this.put<ICartLiteResponse, ICartUpdateDto>('v1/carts/lite', data);
  }

  public async getCartFull(cityId: string): Promise<ICartFullResponse> {
    const options: Options = {
      headers: {
        'x-delivery-type': MMGatewayConfig.DEFAULT_HEADERS.XDeliveryType,
      },
    };
    return this.get<ICartFullResponse>(`v1/checkout/preview?cityId=${cityId}`, options);
  }

  public async putCartFull(data: ICartUpdateDto, cityId: string): Promise<ICartFullResponse> {
    const options: Options = {
      headers: {
        'x-delivery-type': MMGatewayConfig.DEFAULT_HEADERS.XDeliveryType,
      },
    };
    return this.put<ICartFullResponse, ICartUpdateDto>(
      `v1/checkout/preview?cityId=${cityId}`,
      data,
      options
    );
  }

  public async syncCart(): Promise<void> {
    return this.post('market/v1/cart/sync');
  }
}

export const CartClient = new _CartClient();
